export default "__VITE_ASSET__Dkxjb72h__"